<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" epub:type="copyright-page" id="_idContainer005">
<p class="_cip" id="_idParaDest-1">Copyright Information</p>
<p class="cip2-spab"><span class="com-rorohiko-pagestaker-style">vi</span><span class="ital">Llewellyn’s Little Book of Witchcraft</span> Copyright © 2023 by Deborah Blake. </p>
<p class="cip1-nosp">All rights reserved. No part of this book may be used or reproduced in any matter whatsoever, including Internet usage, without written permission from Llewellyn Worldwide Ltd., except in the form of brief quotations embodied in critical articles and reviews.</p>
<p class="cip2-spab">As the purchaser of this e-book, you are granted the non-exclusive, non-transferable right to access and read the text of this e-book on screen. The text may not be otherwise reproduced, transmitted, downloaded, or recorded on any other storage device in any form or by any means. </p>
<p class="cip2-spab">Any unauthorized usage of the text without express written permission of the publisher is a violation of the author’s copyright and is illegal and punishable by law.</p>
<p class="cip2-spab">Photography is used for illustrative purposes only. The persons depicted may not endorse or represent the book’s subject.</p>
<p class="cip2-spab">First e-book edition © 2023</p>
<p class="cip1-nosp">E-book ISBN: 9780738774886</p>
<p class="cip2-spab">Cover cartouche by Freepik</p>
<p class="cip1-nosp">Cover design by Shira Atakpu</p>
<p class="cip1-nosp">Interior art by Llewellyn Art Department</p>
<p class="cip2-spab">Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd.</p>
<p class="cip2-spab">Library of Congress Cataloging-in-Publication Data</p>
<p class="cip1-nosp">Names: Blake, Deborah, author.  </p>
<p class="cip1-nosp">Title: Llewellyn’s little book of witchcraft / Deborah Blake.  </p>
<p class="cip1-nosp">Description: First edition. | Woodbury, Minnesota : Llewellyn Publications, </p>
<p class="cip1-nosp">   [2023] | Series: Llewellyn’s little books ; 16 | Summary: “A small book </p>
<p class="cip1-nosp">   with a brief history of Witchcraft, a summary of modern witchcraft, and </p>
<p class="cip1-nosp">   suggestions for types of practice. Includes basic practices, spells, </p>
<p class="cip1-nosp">   activities, and tips, as well as correspondences”-- Provided by publisher.  </p>
<p class="cip1-nosp">Identifiers: LCCN 2023009330 (print) | LCCN 2023009331 (ebook) | ISBN </p>
<p class="cip1-nosp">   9780738774817 (hardcover) | ISBN 9780738774886 (ebook)  </p>
<p class="cip1-nosp">Subjects: LCSH: Witchcraft. | Magic. | Charms. | Wicca. </p>
<p class="cip1-nosp">Classification: LCC BF1566 .B5345435 2023  (print) | LCC BF1566  (ebook) | </p>
<p class="cip1-nosp">   DDC 133.4/3--dc23/eng/20230624 </p>
<p class="cip1-nosp">LC record available at https://lccn.loc.gov/2023009330</p>
<p class="cip1-nosp">LC ebook record available at https://lccn.loc.gov/2023009331</p>
<p class="cip2-spab">Llewellyn Publications does not participate in, endorse, or have any authority or responsibility concerning private business arrangements between our authors and the public.</p>
<p class="cip2-spab">Any Internet references contained in this work are current at publication time, but the publisher cannot guarantee that a specific reference will continue or be maintained. Please refer to the publisher’s website for links to current author websites.</p>
<p class="cip3-spab-cntr">Llewellyn Publications </p>
<p class="cip34-nosp-cntr">Llewellyn Worldwide Ltd.</p>
<p class="cip34-nosp-cntr">2143 Wooddale Drive</p>
<p class="cip34-nosp-cntr">Woodbury, MN 55125</p>
<p class="cip34-nosp-cntr"><a href="http://www.llewellyn.com" target="_blank">www.llewellyn.com</a></p>
<p class="cip3-spab-cntr">Manufactured in the United States of America</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?ca3a0e6e